(() => {
    const initSticky = () => {
        if (document.readyState !== 'complete') return;
        let Sticky = require('sticky-js');
        let sticky = new Sticky('[data-sticky]');
    };
    document.addEventListener('readystatechange', initSticky);
})();
